import React from 'react';
import classnames from 'classnames';

import Tab from 'components/Misc/Tabs/Tab';

const Tabs = ({ tabs, selected, className }) => {
	const cls = classnames(
		'inline-block rounded-lg bg-white dark:bg-neutral-800 transition-colors',
		className
	);

	return (
		<div className={cls}>
			{tabs?.map(tab =>
				<Tab key={tab.name} tab={tab} selected={selected} />
			)}
		</div>
	);
};

export default Tabs;